
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.16.1
 * Query Engine version: 34ace0eb2704183d2c05b60b52fba5c43c13f303
 */
Prisma.prismaVersion = {
  client: "5.16.1",
  engine: "34ace0eb2704183d2c05b60b52fba5c43c13f303"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.Field_i18nScalarFieldEnum = {
  id: 'id',
  field_key: 'field_key',
  translation_key: 'translation_key',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  api_path: 'api_path',
  deletedAt: 'deletedAt',
  tips_translation_key: 'tips_translation_key'
};

exports.Prisma.User_infoScalarFieldEnum = {
  identityInfo: 'identityInfo',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  luciaUserId: 'luciaUserId',
  channel: 'channel',
  id: 'id',
  deletedAt: 'deletedAt'
};

exports.Prisma.FilterConfigScalarFieldEnum = {
  id: 'id',
  entityTypeName: 'entityTypeName',
  filterGroupList: 'filterGroupList',
  defaultFilter: 'defaultFilter',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  entityViewName: 'entityViewName',
  shouldRenderDatePicker: 'shouldRenderDatePicker',
  shouldRenderSearchBar: 'shouldRenderSearchBar',
  apiPath: 'apiPath',
  tableTitleI18nKey: 'tableTitleI18nKey',
  deletedAt: 'deletedAt'
};

exports.Prisma.TableConfigScalarFieldEnum = {
  id: 'id',
  tableId: 'tableId',
  version: 'version',
  entityName: 'entityName',
  viewName: 'viewName',
  apiPath: 'apiPath',
  tableConfigJson: 'tableConfigJson',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  resourceKey: 'resourceKey',
  relatedEntityName: 'relatedEntityName',
  deletedAt: 'deletedAt'
};

exports.Prisma.HeaderConfigScalarFieldEnum = {
  id: 'id',
  entityTypeName: 'entityTypeName',
  headerGroupList: 'headerGroupList',
  defaultSorter: 'defaultSorter',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  entityViewName: 'entityViewName',
  apiPath: 'apiPath',
  version: 'version',
  sorterList: 'sorterList',
  deletedAt: 'deletedAt'
};

exports.Prisma.TranslationScalarFieldEnum = {
  id: 'id',
  key: 'key',
  zh: 'zh',
  en: 'en',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  type: 'type',
  updatedAt: 'updatedAt'
};

exports.Prisma.Tips_translationScalarFieldEnum = {
  id: 'id',
  key: 'key',
  zh: 'zh',
  en: 'en',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.LuciaUserScalarFieldEnum = {
  id: 'id',
  username: 'username',
  passwordHash: 'passwordHash',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  phone: 'phone',
  shareCode: 'shareCode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  user_type: 'user_type',
  nickname: 'nickname',
  user_company: 'user_company',
  gray_feature: 'gray_feature',
  ban_type: 'ban_type',
  reg_platform: 'reg_platform',
  max_session_count: 'max_session_count'
};

exports.Prisma.LuciaAccountScalarFieldEnum = {
  userId: 'userId',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  image: 'image',
  raw: 'raw',
  username: 'username',
  deletedAt: 'deletedAt'
};

exports.Prisma.LuciaSessionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  updatedAt: 'updatedAt',
  platform: 'platform'
};

exports.Prisma.LuciaWechatMPScalarFieldEnum = {
  id: 'id',
  expiresAt: 'expiresAt',
  scanAt: 'scanAt',
  usedAt: 'usedAt',
  qrCode: 'qrCode',
  wechatOpenId: 'wechatOpenId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LuciaSMSVerificationScalarFieldEnum = {
  id: 'id',
  code: 'code',
  phone: 'phone',
  expiresAt: 'expiresAt',
  type: 'type',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LuciaEmailVerificationScalarFieldEnum = {
  id: 'id',
  code: 'code',
  email: 'email',
  expiresAt: 'expiresAt',
  type: 'type',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.InvoiceScalarFieldEnum = {
  id: 'id',
  amount: 'amount',
  invoiceType: 'invoiceType',
  title: 'title',
  taxNumber: 'taxNumber',
  bankName: 'bankName',
  accountNumber: 'accountNumber',
  address: 'address',
  phoneNumber: 'phoneNumber',
  email: 'email',
  orderNumber: 'orderNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  luciaUserId: 'luciaUserId',
  deletedAt: 'deletedAt'
};

exports.Prisma.WithdrawalScalarFieldEnum = {
  id: 'id',
  bankAccount: 'bankAccount',
  contact: 'contact',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  luciaUserId: 'luciaUserId',
  bankName: 'bankName',
  branchName: 'branchName',
  idNumber: 'idNumber',
  realName: 'realName',
  deletedAt: 'deletedAt'
};

exports.Prisma.Meta_configScalarFieldEnum = {
  id: 'id',
  key: 'key',
  value: 'value',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.Gray_kvScalarFieldEnum = {
  id: 'id',
  gray_name: 'gray_name',
  gray_key: 'gray_key',
  desc: 'desc'
};

exports.Prisma.OAuthClientScalarFieldEnum = {
  id: 'id',
  clientId: 'clientId',
  clientSecret: 'clientSecret',
  redirectUris: 'redirectUris',
  grants: 'grants',
  scope: 'scope',
  name: 'name',
  logoUri: 'logoUri',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OAuthTokenScalarFieldEnum = {
  id: 'id',
  accessToken: 'accessToken',
  accessTokenExpiresAt: 'accessTokenExpiresAt',
  refreshToken: 'refreshToken',
  refreshTokenExpiresAt: 'refreshTokenExpiresAt',
  scope: 'scope',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  clientId: 'clientId',
  userId: 'userId'
};

exports.Prisma.OAuthAuthorizationCodeScalarFieldEnum = {
  id: 'id',
  authorizationCode: 'authorizationCode',
  expiresAt: 'expiresAt',
  redirectUri: 'redirectUri',
  scope: 'scope',
  codeChallenge: 'codeChallenge',
  codeChallengeMethod: 'codeChallengeMethod',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  clientId: 'clientId',
  userId: 'userId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.TranslationType = exports.$Enums.TranslationType = {
  FRONTEND: 'FRONTEND',
  FILTER_CONFIG: 'FILTER_CONFIG',
  TABLE_CONFIG: 'TABLE_CONFIG',
  FIELD: 'FIELD'
};

exports.BanType = exports.$Enums.BanType = {
  NORMAL: 'NORMAL',
  LIMITED: 'LIMITED',
  BANNED: 'BANNED',
  TEMPORARY_BANNED: 'TEMPORARY_BANNED'
};

exports.Prisma.ModelName = {
  field_i18n: 'field_i18n',
  user_info: 'user_info',
  filterConfig: 'filterConfig',
  tableConfig: 'tableConfig',
  headerConfig: 'headerConfig',
  translation: 'translation',
  tips_translation: 'tips_translation',
  LuciaUser: 'LuciaUser',
  LuciaAccount: 'LuciaAccount',
  LuciaSession: 'LuciaSession',
  LuciaWechatMP: 'LuciaWechatMP',
  LuciaSMSVerification: 'LuciaSMSVerification',
  LuciaEmailVerification: 'LuciaEmailVerification',
  Invoice: 'Invoice',
  Withdrawal: 'Withdrawal',
  meta_config: 'meta_config',
  gray_kv: 'gray_kv',
  OAuthClient: 'OAuthClient',
  OAuthToken: 'OAuthToken',
  OAuthAuthorizationCode: 'OAuthAuthorizationCode'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
